import { reduce } from 'lodash';

const withAll = (...args) => WrappedComponent => reduce(args, (result, arg) => arg(result), WrappedComponent);

export default withAll;
